import { useSelector } from "react-redux";
import CompetitorsPageSpeed from "../../../../components/MarketPositioning/Scout/CompetitorsPageSpeed/CompetitorsPageSpeed";
import Page404 from "../../../../components/Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";

const CompetitorsPageSpeedScreen = ({
  userToken,
  response,
}: {
  userToken: any;
  response: any;
}) => {
  const userData = useSelector(selectUserData);
  const hasViewCompetitorsPageSpeedPermission = CheckPermissions(
    userData?.data?.products?.market_positioning,
    "scout",
    "view_external_page_speed_performance"
  );
  return (
    <>
      {hasViewCompetitorsPageSpeedPermission ? (
        <CompetitorsPageSpeed userToken={userToken} response={response} />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default CompetitorsPageSpeedScreen;
